import { InvitacionesService } from './../../services/invitacion/invitacion.service';
import { NgModule } from "@angular/core";
import { IonicPageModule, IonicPage, LoadingController, AlertController } from "ionic-angular";
import { ActivatePage } from "./activate";

import { TranslateModule } from "@ngx-translate/core";

@IonicPage()
@NgModule({
  declarations: [ActivatePage],
  imports: [ IonicPageModule.forChild(ActivatePage), TranslateModule.forChild()],
  providers: [InvitacionesService, LoadingController, AlertController],
  exports: [ActivatePage]
})
export class ActivatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/activate/activate.module.ts